import { TYPO } from "styles/Typo";
import { SurveyTitle } from "../component";
import { ActiveRadioIcon, InactiveRadioIcon } from "../Icon";
import { useEffect, useRef } from "react";
import gsap from "gsap";

function SaaSurveyCategoryIndex({
  onOptionSelect,
  selectedOption,
  options,
}: {
  onOptionSelect: (option: string) => void;
  selectedOption: string;
  options: { id: string; label: string }[];
}) {
  const optionRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const tl = gsap.timeline();
    const elements = optionRefs.current.filter(
      (el): el is HTMLDivElement => !!el
    );

    tl.fromTo(
      elements,
      {
        opacity: 0,
        x: (index: number) => 15 + index * 10,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.8,
        ease: "easeInOut",
        stagger: 0.1,
      },
      "+=0.2"
    );
  }, []);

  return (
    <div className="bg-background relative w-full ">
      {/* Question Container */}
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        <SurveyTitle text={"어디에 쓸 돈을 마련하시나요?"} />

        {/* Options Container */}
        <div className="box-border content-stretch flex flex-col items-start justify-center px-6 py-4 relative shrink-0 w-full overflow-x-hidden">
          {options.map((option, index) => (
            <div
              key={option.id}
              ref={(el) => {
                optionRefs.current[index] = el;
              }}
              className="box-border content-stretch flex gap-2 items-center justify-center px-1 py-2.5 relative shrink-0 cursor-pointer"
              onClick={() => onOptionSelect(option.id)}
              data-gtm-id={`saa-survey-cat-radio-btn`}
              data-testid={`saa-survey-cat-radio-btn`}
            >
              {/* Radio Button */}
              <div className="relative shrink-0 size-5">
                <div className="absolute inset-[8.333%]">
                  {selectedOption === option.id ? (
                    <ActiveRadioIcon />
                  ) : (
                    <InactiveRadioIcon />
                  )}
                </div>
              </div>

              {/* Option Label */}
              <div
                className={`${
                  selectedOption === option.id ? "text-blue50" : "text-gray80"
                } ${TYPO.TYPO5_1_MD}`}
              >
                {option.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SaaSurveyCategoryIndex;
